export default function getCardinalPointFromStoneId(stoneId) {
  // eslint-disable-next-line
  switch (stoneId.charAt(0)) {
    case 'n':
      return 'North';
    case 'e':
      return 'East';
    case 's':
      return 'South';
    case 'w':
      return 'West';
  }
}
